import React from 'react';
import { createRoot } from 'react-dom/client';
import { HoneyloveWindow } from '../models/HoneyloveWindow';
import { RecoilRoot } from 'recoil';
import '../recoil/atoms';
import App from './App';

declare let __webpack_public_path__: string;
declare const window: HoneyloveWindow;

// // uncomment this block for accessability logging
// if (process.env.NODE_ENV !== 'production') {
//   // eslint-disable-next-line @typescript-eslint/no-var-requires
//   const axe = require('@axe-core/react');
//   axe(React, ReactDOM, 2000);
// }

if (document.body && !document.getElementById('root')) {
  const rootElement = document.createElement('div');
  rootElement.id = 'root';
  document.body.appendChild(rootElement);

  const buildAssetPath = (url: string) => url.replace(/(\/assets\/)(.*)/, '$1');
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  __webpack_public_path__ = buildAssetPath(window.Honeylove.environment.assetUrl);

  const root = createRoot(rootElement);

  // The fallback was overlapping with the individual app fallbacks
  // so we are only using an empty span here
  root.render(
    <RecoilRoot>
      <React.Suspense fallback={<span />}>
        <App />
      </React.Suspense>
    </RecoilRoot>,
  );
}
